export default __webpack_public_path__ + "mini-icon-android-11@2x.png";